import { render, staticRenderFns } from "./ImageRender.vue?vue&type=template&id=fbc8acce"
import script from "./ImageRender.vue?vue&type=script&lang=js"
export * from "./ImageRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports